import dayjs from "dayjs";

export const getDaysDifference = (startDate, endDate) => dayjs(endDate).diff(dayjs(startDate), 'day');